<template>
	<div>
		<apexchart
			type="pie"
			:options="chartOptions"
			:series="series"
			width="550"
			height="600"
		/>
	</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { mapGetters, mapActions } from 'vuex';

async function created() {
	this.loadStatistics(this.currentSubsidiary);
}

async function loadStatistics(newSubsidiary) {
	if (newSubsidiary.id) {
		try {
			const { data: response } = await this.$http.get(
				`accounting-seats?subsidiaryId=${newSubsidiary.id}`,
			);
			const amountDebit = response
				.map(item => item.totalDebe)
				.reduce((prev, curr) => prev + curr, 0);
			const amountCredit = response
				.map(item => item.totalHaber)
				.reduce((prev, curr) => prev + curr, 0);
			const amountTotal = amountDebit - amountCredit;
			this.series = [amountDebit, amountCredit, amountTotal];
			this.debit = Number(amountDebit.toFixed(2));
			this.credit = Number(amountCredit.toFixed(2));
			this.amount = Number(amountTotal.toFixed(2));
			this.series = [this.debit, this.credit, this.amount];
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}
}

async function subsidiaryChange(newSubsidiary) {
	this.loadStatistics(newSubsidiary);
}

export default {
	name: 'donut',
	components: { VueApexCharts },
	created,
	methods: {
		...mapActions('subsidiary', {
			$loadSubsidiaries: 'loadSubsidiaries',
			$setCurrentSubsidiary: 'setCurrentSubsidiary',
			$updateSubsidiaries: 'updateSubsidiaries',
		}),
		loadStatistics,
		subsidiaryChange,
	},
	data() {
		return {
			chartOptions: {
				labels: ['Label 1', 'Label 2', 'Label 3', 'Label 4'],
			},
			series: [44, 55, 13, 43],
		};
	},
	computed: {
		...mapGetters('subsidiary', ['currentSubsidiary']),
	},
	watch: {
		currentSubsidiary: subsidiaryChange,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/shared/apexCharts/pie.vue